import app from 'flarum/forum/app';

let loading = false;
let hasLoaded = false;
let loadedData = [];
let onLoadedCallbacks = [];

export default function loadAgentsList(onLoadedCallback) {
  // Tags have already been loaded
  if (hasLoaded) {
    onLoadedCallback(loadedData);
    return;
  }

  // Load agents if not already loading
  if (!loading) {
    loading = true;

    // Load agents
    app.store.find('support/tickets/agents').then((data) => {
      hasLoaded = true;
      loading = false;
      loadedData = data;

      onLoadedCallback(data);

      // Give callback
      onLoadedCallbacks.map((cb) => cb(data));

      m.redraw();
    });
  } else {
    onLoadedCallbacks.push(onLoadedCallback);
  }
}
